export enum AuthError {
	UNAUTHENTICATED = "You must login first",
	EMAIL_NOT_VERIFIED = "Email has not been verified",
	TOKEN_EXPIRED = "You've been logged out",
	INSUFFICIENT_PERMISSIONS = "You do not have permission to see this data",
}
